// extracted by mini-css-extract-plugin
export var chevron = "_ix-4";
export var chevronExpanded = "_ix-5";
export var row = "_ix-0";
export var rowBody = "_ix-6";
export var rowDescription = "_ix-7";
export var rowHeader = "_ix-1";
export var rowTitle = "_ix-2";
export var rowTitleComplete = "_ix-3";